export default "/_next/static/chunks/fonts/Channel4Horseferry-Medium-a3794b5f5be6d83ff13cc80c1b45e1ef.woff2";